module.exports = __webpack_public_path__ + "static/media/facepalm.4b6f46f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/facepalm.svg
// module id = 717
// module chunks = 0